/**
 * CrowChat Agent Configuration
 * Demo chat agent for showcasing multi-agent architecture
 */

export const crowChatConfig = {
  id: 'crowchat',
  name: 'CrowChat',
  displayName: 'Crow AI Assistant',
  description: 'A demo conversational AI assistant powered by CrowAI',
  
  // Agent branding
  branding: {
    title: 'How do you want to manage things today?',
    welcomeMessage: 'How can I help you today?',
    placeholder: 'Type your message here...',
  },

  // API configuration
  api: {
    endpoint: '/api/chat', // Same endpoint as BroChat
    method: 'POST',
    timeout: 30000,
    useMockApi: false, // Use real backend API
  },

  // Feature flags
  features: {
    imageUpload: false,
    voiceInput: false,
    fileAttachments: false,
    messageHistory: true,
  },

  // UI customization
  ui: {
    showLogo: true,
    showWelcomeMessage: true,
    maxMessageLength: 2000,
    maxImages: 0,
  },
};

export default crowChatConfig;
